import { useEffect, useState } from 'preact/hooks';
import {
  ALL_FILTERS,
  headline,
  pipelineByStage,
  type DashboardBody,
} from '../../shared/insights/dashboard';
import { useI18n } from '../i18n';
import { apiGet } from '../lib/api';
import { compact, headlineTiles, thisMonth } from '../pages/Dashboard';
import { DeliveredRing, StageDonut } from './GlanceCharts';

// Home's "This year at a glance" (D78): the dashboard's headline tiles for this year, all
// entities. Only for people the broker lets read the dashboard; anything else shows nothing.
export function HomeGlance() {
  const { t } = useI18n();
  const [data, setData] = useState<DashboardBody | null>(null);
  const today = thisMonth();

  useEffect(() => {
    let live = true;
    apiGet<DashboardBody>(`/api/dashboard?year=${today.slice(0, 4)}`)
      .then((d) => live && setData(d))
      .catch(() => undefined);
    return () => {
      live = false;
    };
  }, [today]);

  if (!data?.current) return null;
  const h = headline(data, ALL_FILTERS, today);
  // Delivered is shown as the ring, so its tile is left out here (D110).
  const tiles = headlineTiles(h, t).filter((x) => x.key !== 'delivered');
  return (
    <section class="stack" aria-labelledby="home-glance">
      <div class="card__head">
        <h2 id="home-glance" class="card__title">
          {t('home.glance.title', { year: String(data.year) })}
        </h2>
        <a href="#/dashboard">{t('home.glance.open')}</a>
      </div>
      <p class="caption">
        {t('dash.period.ytd')} · {t('dash.amounts')}
        {!data.scope.all &&
          ` · ${t('dash.scopeHead', { departments: data.scope.departments.join(', ') })}`}
      </p>
      <div class="glance-row">
        <DeliveredRing
          pct={h.deliveredPct}
          delivered={compact(h.delivered)}
          ordered={compact(h.poValue)}
        />
        <StageDonut stages={pipelineByStage(data, ALL_FILTERS)} />
      </div>
      <ul class="tiles dash-tiles" aria-label={t('dash.headline')}>
        {tiles.map((tile) => (
          <li key={tile.key} class={`tile tile--tone tile--tone-${tile.key}`}>
            <span class="caption">{t(tile.label)}</span>
            <span class="tile__value" dir="ltr">
              {tile.value}
            </span>
            <span>{tile.sub}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
